import Language from './language.vue'
export default Language



// WEBPACK FOOTER //
// ./src/components/main/components/language/index.js